import { Table, TableProps } from 'antd';

const TableCustom = <T extends object>(props: TableProps<T>) => {
    return (
        <Table
            {...props}
            scroll={{
                y: window.innerHeight * 0.7 - 48 - 55,
                ...props.scroll,
            }}
        />
    );
};

export default TableCustom;